module.exports = __webpack_public_path__ + "img/4.bef4df5f.jpg";